import styled from 'styled-components';

export const HeaderContainer = styled.div`
  min-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BodyContainer = styled.main`
  flex-grow: 1;
  padding-bottom: 100px;
`;

export const FooterContainer = styled.div`
  min-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f7f2f0;

  @media print {
    html,
    body {
      overflow: hidden;
    }

    .leaflet-control-layers,
    .leaflet-control-zoom {
      display: none;
    }

    .turn-by-tyrn {
      display: flex;
    }

    .custom-retailer-marker {
      color: #0073ff !important;
    }

    body * {
      visibility: hidden;
    }

    .leaflet-routing-collapse-btn {
      visibility: hidden;
    }

    #map,
    #routing-instructions {
      visibility: visible;
      position: relative;
    }

    #map {
      width: 665px;
      break-after: always;
    }

    .routing-wrapper {
      margin-left: 0;
    }

    #routing-instructions {
      max-width: 665px;
      height: 100%;
      .leaflet-routing-container {
        width: 95vw;
        background-color: white;
        border-radius: none;
        box-shadow: none;
        padding: 0;
        margin-bottom: 0;
        font-size: 16px;

        .leaflet-routing-alt-minimized {
          display: none;
        }
      }
      break-before: always;
    }

    .no-print {
      display: none !important;
    }
  }
`;
